import useCustomerProductList from '../commerce-api/hooks/useCustomerProductList'

const useProductNotification = () => useCustomerProductList('notifyWhenInStock', 'custom_1')

export default useProductNotification
